<template>
  <div id="registration-screen">
    <div class="info-text">
      {{ $t('registrationScreen.infoText') }}
    </div>
    <registration-modal :initialCouponCode="this.$route.query.couponCode" />
    <footer
      class="py-11 bg-dark position-relative"
      data-bg-img="https://motivac.io/assets/images/bg/02.png"
      style="
        background-image: url('https://motivac.io/assets/images/bg/02.png');
      "
    >
      <div class="shape-1" style="height: 150px; overflow: hidden">
        <svg
          viewBox="0 0 500 150"
          preserveAspectRatio="none"
          style="height: 100%; width: 100%"
        >
          <path
            d="M0.00,49.98 C150.00,150.00 271.49,-50.00 500.00,49.98 L500.00,0.00 L0.00,0.00 Z"
            style="stroke: none; fill: #FFF;"
          ></path>
        </svg>
      </div>

      <div class="container mt-11 pb-5">
        <div class="row text-white text-center mt-8">
          <div class="col">
            <hr class="mb-8" />
            motivac.io is a
            <u
              ><a
                class="text-white measure"
                data-measure-key="click-codeyard"
                data-measure-category="social"
                href="https://codeyard.eu"
                target="_blank"
                >CodeYard</a
              ></u
            >
            company, built with ❤️ <br />
            All Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import RegistrationModal from '@/components/shared/modals/RegistrationModal';

export default {
  name: 'RegistrationScreen',
  components: {
    RegistrationModal,
  },
  created() {},
};
</script>

<style lang="scss" scoped>
#registration-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  //padding: 0 20%;
  min-height: 100vh;
  background-color: #FFF;
  .logo {
    min-height: 80px;
    margin: 40px;
  }
  .info-text {
    color: #f97f51;
    border: 2px dashed #f97f51;
    border-radius: 8px;
    margin: 10px 0;
    padding: 2%;
    font-size: 0.8rem;
  }
  footer {
    width: 100vw;
    background-color: #060927 !important;
    margin-bottom: -36px;
  }
}
</style>
